module.exports = __webpack_public_path__ + "img/military_base-hotspot-4.1.40bd6c91.png";